/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React, { createRef } from "react";
import PropTypes from "prop-types";
import Swiper from 'swiper/swiper-bundle.min.js'
import 'swiper/swiper.less'
import 'swiper/components/pagination/pagination.less'
import 'swiper/components/effect-coverflow/effect-coverflow.less'
import utils from "../../utils/utils";
import "./style.less";

class PipelineImgSwiper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      
    };
    this.swiperRef = createRef();
    this.swiperPaginationRef = createRef();
  }

  componentDidMount() {
    // 轮播组件初始化
    const delayTime = isNaN(Number(this.props.config.baseConfig.time)) ? 3000 : Number(this.props.config.baseConfig.time);
    const swiper = new Swiper(this.swiperRef.current, {
      effect: 'coverflow',
      coverflowEffect: {
        rotate: 46,
      },
      loop: true,
      slidesPerView: 1.5,
      spaceBetween: 0,
      centeredSlides: true,
      pagination: {
        el: this.swiperPaginationRef.current,
        clickable: true,
      },
      autoplay: {
        delay: delayTime,
      },
    });
  }

  handleItemClick = (item, index) => {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: item.link,
        props: this.props,
        index
      })
      return
    }
    if (!item.link) {
      // 空白不跳转
      return;
    }
    const baseConfig = this.props.config.baseConfig;
    const options = {
      link: item.link,
      type: baseConfig.sortType,
      sort: index,
    };

    const convertUrl = utils.convertHref(item.link);
    utils.jumpToUrl(this.props.routeParams, convertUrl, item.link, options, -1, this.props, false);

  }

  render() {
    const { baseConfig, imgsList } = this.props.config;
    return (
      <div
        className="pipeline-imgSwiper"
        id={this.props['customAttributes']['data-component-id']}
        name={baseConfig.title}
        {...this.props['customAttributes']}
      >
        <div className="swiper-container" ref={this.swiperRef}>
          <div className="swiper-wrapper">
            {imgsList.map((item, index) => {
              return (
                <div className="swiper-slide" onClick={this.handleItemClick.bind(this, item, index)} key={index}>
                  <img className="img-item" src={utils.formatImgUrl(item.src, this.props.webpSupport)} alt="" />
                </div>
              );
            })}
          </div>
          <div className="swiper-pagination" ref={this.swiperPaginationRef}></div>
        </div>
      </div>
    );
  }
}

PipelineImgSwiper.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineImgSwiper };
export default PipelineImgSwiper;



// WEBPACK FOOTER //
// ./components/pipeline-imgSwiper/index.js